// @flow
import React, { Component } from 'react'
import { Breadcrumb } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import { connect } from 'react-redux'
import * as actions from '../actions'
import { getOpportunityById, getOpportunity } from '../selectors'
import Loading from '../components/Loading'
import styles from './opportunityPage.less'
import Organization from '../components/Organization'
import Opportunity from '../components/Opportunity'
import type { OpportunityType } from '../types/OpportunityType'

class OpportunityPage extends Component {
  props: {
    showNav: ?boolean,
    isFetching: boolean,
    item: OpportunityType,
    fetchOpportunity: Function,
    params: {
      id: string,
    },
  }

  componentWillMount() {
    const { id } = this.props.params
    if (!this.props.item || this.props.item.id !== id) {
      this.props.fetchOpportunity({ id })
    }
  }

  render() {
    const { item, isFetching, showNav = true } = this.props
    if (!item || isFetching) {
      return <Loading className="text-center" />
    }
    const { name, organization } = item
    return (
      <div className={styles.page}>
        {showNav
          ? <Breadcrumb>
              <LinkContainer to="/opportunities">
                <Breadcrumb.Item>
                  Opportunites & Categories List
                </Breadcrumb.Item>
              </LinkContainer>
              <Breadcrumb.Item active>
                {name}
              </Breadcrumb.Item>
            </Breadcrumb>
          : null}
        <Opportunity {...item} />
        <Organization {...organization} />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  isFetching: getOpportunity(state).isFetching,
  item: getOpportunityById({ state, id: Number(ownProps.params.id) }),
})

export default connect(mapStateToProps, actions)(OpportunityPage)



// WEBPACK FOOTER //
// ./src/pages/OpportunityPage.js